<template>
	<edit :classify="classify" :classify-name="classifyName"></edit>
</template>

<script>
	import edit from './product_edit.vue'
	
	export default {
		name: 'product_apply',
		
		props: {
			classify: String,
			classifyName: String
		},
		
		components: {
			edit
		}
	}
</script>